export default "__VITE_ASSET__Om1x0fPz__";